import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { NotificationService } from '@core/services';

import { ImportType, getLocalizedImportTypes } from '@/tax/models';

@Component({
    selector: 'app-parsing-file-select',
    templateUrl: './parsing-file-select.component.html',
    styleUrls: ['./parsing-file-select.component.scss'],
    standalone: false,
})
export class ParsingFileSelectComponent implements OnInit {
    @Input() includeStartImportButton = true;
    @Input() stretch = false;
    @Output() readonly fileSelected = new EventEmitter<FormData>();

    formGroup = new FormGroup({
        type: new FormControl<ImportType | undefined>(undefined, [Validators.required]),
    });
    typeOptions = Object.values(ImportType)
        .filter((type) => type !== ImportType.Csv)
        .map((type) => {
            return {
                name: getLocalizedImportTypes()[type],
                type: type,
            };
        });
    fileEmitted = false;
    importType = ImportType;
    formData?: FormData;
    fileName = '';

    constructor(private notificationService: NotificationService) {}

    ngOnInit() {
        this.reset();
    }

    onFileSelected(event: any): void {
        this.formData = new FormData();
        if (event.currentTarget?.files?.[0] ?? false) {
            let file = event.currentTarget.files[0];
            if (file !== undefined) {
                this.fileName = file.name;
                this.formData.append('file', file, file.name);
                this.formData.append('type', this.formGroup.controls.type.value ?? ImportType.TaxOnWeb);
            }
        }
    }

    startImport() {
        if (this.checkSelectedFile()) {
            this.fileSelected.emit(this.formData);
            this.fileEmitted = true;
        }
    }

    reset() {
        this.formGroup.reset();
        this.formGroup.controls.type.patchValue(undefined);
        this.formData = undefined;
        this.fileName = '';
        this.fileEmitted = false;
    }

    private checkSelectedFile(): boolean {
        const file = this.formData?.get('file') as File;
        const type = this.formGroup.controls.type.value;
        if (type === undefined) {
            this.notificationService.errorMessage($localize`:@@parsingFileSelect.error.noTypeSelected:Geen type geselecteerd.`);
            return false;
        }

        if (file === undefined) {
            this.notificationService.errorMessage($localize`:@@parsingFileSelect.error.noFileSelected:Geen bestand geselecteerd.`);
            return false;
        }

        if (type === ImportType.TaxOnWeb && file.type !== 'application/pdf' && !file.name.includes('.tow')) {
            this.notificationService.errorMessage(
                $localize`:@@parsingFileSelect.error.fileTypeIncorrectTOW:Type van het geselecteerde bestand is incorrect. Tax-on-web vereist ofwel een PDF- ofwel een TOW-bestand.`,
            );
            return false;
        }

        if (type === ImportType.Kluwer && file.type !== 'application/pdf') {
            this.notificationService.errorMessage(
                $localize`:@@parsingFileSelect.error.fileTypeIncorrectKluwer:Type van het geselecteerde bestand is incorrect. Kluwer vereist een PDF-bestand.`,
            );
            return false;
        }

        if (type === ImportType.Sofisk && file.type !== 'application/pdf') {
            this.notificationService.errorMessage(
                $localize`:@@parsingFileSelect.error.fileTypeIncorrectSofisk:Type van het geselecteerde bestand is incorrect. Sofisk vereist een PDF-bestand.`,
            );
            return false;
        }

        return true;
    }
}
